/*============================================================================
  Realtime Watch - Handles real-time analog/digital watch rendering,
  including main time hands, date/week indicators, stopwatch, and extra dials
==============================================================================*/
theme.RealTime = function () {
  // Cancel previous animation loop if already running (prevents multi-loop speedup on section/variant change)
  if (window._sylviRealTimeRAF) {
    cancelAnimationFrame(window._sylviRealTimeRAF);
    window._sylviRealTimeRAF = null;
  }

  // DOM element references
  const watch_face = document.getElementById("watch_face");
  const secondHand = document.querySelector(".second-hand");
  const minsHand = document.querySelector(".min-hand");
  const hourHand = document.querySelector(".hour-hand");
  const dateImage = document.querySelector(".date-window img");
  const weekImage = document.querySelector(".week-window img");
  const sweep_seconds = watch_face?.dataset.sweep === "true";
  window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };

  // Chronograph elements
  const chrono_mili = document.querySelector("#chrono_mili_second");
  const chrono_sec = document.querySelector("#chrono_second");
  const chrono_min = document.querySelector("#chrono_minute");
  const chrono_buttonA = document.querySelector("#buttonA");
  const chrono_buttonB = document.querySelector("#buttonB");

  // Additional dials and indicators
  const weekImage8113 = document.querySelector("#chrono_week_hand");
  const innerImg1541 = document.querySelector("#chrono_inner_1541");
  const outerImg1541 = document.querySelector("#chrono_outer_1541");
  const SunMooninnerImg1541 = document.querySelector("#sunmoon_inner_1541");
  const SunMoonOuterImg1541 = document.querySelector("#sunmoon_outer_1541");
  const dayNightInnerImage = document.querySelector("#day_night_inner_image");
  const dayNightSecondHand = document.querySelector("#day_night_second_hand");
  const dayNightOuterImage = document.querySelector("#day_night_outer_image");

  let stopwatchRunning = false;
  let rotationMiliDegree = 0;
  let rotationSecDegree = 0;
  let rotationMinDegree = 0;

  // Main loop: continuously updates time and visual rotation values
  function setTime() {
    const curDateTime = new Date();
    const dateNumber = curDateTime.getDate();
    const dayNumber = curDateTime.getDay();

    const degreesPerDay = 360 / 31;
    const degreesPerWeek = 360 / 7;

    const hour = ((curDateTime.getHours() + curDateTime.getMinutes() / 60) / 12) * 360 + 90;
    const minute = (curDateTime.getMinutes() / 60) * 360 + 90;
    const second = sweep_seconds
      ? ((curDateTime.getSeconds() + (curDateTime.getMilliseconds() / 1000)) / 60) * 360 + 90
      : (curDateTime.getSeconds() / 60) * 360 + 90;

    const dateDeg = 360 - (dateNumber * degreesPerDay - degreesPerDay);
    const weekDeg = 360 - (dayNumber * degreesPerWeek - degreesPerWeek);
    const week8113Deg = dayNumber * degreesPerWeek;

    const ampmDeg = (((curDateTime.getHours() - 6 + 24) % 24 + curDateTime.getMinutes() / 60) * 15) % 360;
    const dayNightDeg = ampmDeg;
    const hourBasedDeg = ((curDateTime.getHours() + curDateTime.getMinutes() / 60) / 24) * 360 + 90;

    // console.log("second", second);
    setHands(hour, minute, second, dateDeg, weekDeg, week8113Deg, ampmDeg, dayNightDeg, hourBasedDeg);
    window._sylviRealTimeRAF = requestAnimationFrame(setTime);
  }
  // Applies rotation values to respective DOM elements
  function setHands(hour, min, sec, date, week, week8113, ampm, dayNight, hourBased) {
    if (hourHand) hourHand.style.transform = `rotate(${hour}deg)`;
    if (minsHand) minsHand.style.transform = `rotate(${min}deg)`;
    if (secondHand) secondHand.style.transform = `rotate(${sec}deg)`;
    if (dateImage) dateImage.style.transform = `rotate(${date}deg)`;
    if (weekImage) weekImage.style.transform = `rotate(${week}deg)`;
    if (weekImage8113) weekImage8113.style.transform = `rotate(${week8113}deg)`;
    if (SunMooninnerImg1541) SunMooninnerImg1541.style.transform = `rotate(${ampm}deg)`;
    if (dayNightInnerImage) dayNightInnerImage.style.transform = `rotate(${dayNight}deg)`;
    if (dayNightSecondHand) dayNightSecondHand.style.transform = `rotate(${hourBased}deg)`;
  }

  // Initial setup: sets CSS variables and triggers animations/start loop
  function initRealTimeWatch() {
    const curDateTime = new Date();
    const dateNumber = curDateTime.getDate();
    const dayNumber = curDateTime.getDay();

    const degreesPerDay = 360 / 31;
    const degreesPerWeek = 360 / 7;

    const hour = ((curDateTime.getHours() + curDateTime.getMinutes() / 60) / 12) * 360 + 90;
    const minute = (curDateTime.getMinutes() / 60) * 360 + 90;
    const second = (curDateTime.getSeconds() / 60) * 360 + 90;
    const dateDeg = 360 - (dateNumber * degreesPerDay - degreesPerDay);
    const weekDeg = 360 - (dayNumber * degreesPerWeek - degreesPerWeek);
    const week8113Deg = dayNumber * degreesPerWeek;
    const ampmDeg = (((curDateTime.getHours() - 6 + 24) % 24 + curDateTime.getMinutes() / 60) * 15) % 360;
    const dayNightDeg = ampmDeg;
    const hourBasedDeg = ((curDateTime.getHours() + curDateTime.getMinutes() / 60) / 24) * 360 + 90;
    // console.log(hourBasedDeg);

    const root = document.documentElement;
    root.style.setProperty("--rotate-change-hour", `${hour}deg`);
    root.style.setProperty("--rotate-change-minute", `${minute}deg`);
    root.style.setProperty("--rotate-change-second", `${second}deg`);
    root.style.setProperty("--rotate-change-date", `${dateDeg}deg`);
    root.style.setProperty("--rotate-change-week", `${weekDeg}deg`);
    root.style.setProperty("--rotate-change-week8113", `${week8113Deg}deg`);
    root.style.setProperty("--rotate-change-ampm1541", `${ampmDeg}deg`);
    root.style.setProperty("--rotate-change-daynight", `${dayNightDeg}deg`);
    root.style.setProperty("--rotate-change-hourbased", `${hourBasedDeg}deg`);

    // Show all relevant watch parts
    [
      chrono_mili, chrono_sec, chrono_min, chrono_buttonA, chrono_buttonB,
      weekImage, dateImage, secondHand, minsHand, hourHand,
      weekImage8113, innerImg1541, outerImg1541,
      SunMooninnerImg1541, SunMoonOuterImg1541, dayNightInnerImage, dayNightSecondHand, dayNightOuterImage
    ].forEach(el => el && (el.style.display = "block"));

    // Begin animation sequence
    setTimeout(() => {
      if (chrono_buttonA && chrono_buttonB) {
        requestAnimationFrame(() => {
          buttonAnimation();
          requestAnimationFrame(() => {
            buttonAnimation();
            requestAnimationFrame(() => {
              setTime();
              buttonBAnimation();
            });
          });
        });
      } else {
        window._sylviRealTimeRAF = requestAnimationFrame(setTime);
      }
    }, 2000);
  }

  /*==============================
    Stopwatch logic & animation
  ==============================*/
  function rotateSec() {
    rotationSecDegree += 6;
    if (chrono_sec) chrono_sec.style.transform = `rotate(${rotationSecDegree}deg)`;
    if (stopwatchRunning) setTimeout(rotateSec, 1000);
  }

  function rotateMin() {
    rotationMinDegree += 0.1;
    if (chrono_min) chrono_min.style.transform = `rotate(${rotationMinDegree}deg)`;
    if (stopwatchRunning) setTimeout(rotateMin, 1000);
  }

  function rotateMili() {
    rotationMiliDegree += 45;
    if (chrono_mili) chrono_mili.style.transform = `rotate(${rotationMiliDegree}deg)`;
    if (stopwatchRunning) setTimeout(rotateMili, 100);
  }

  // Visual button press feedback
  function buttonAnimation() {
    if (!chrono_buttonA) return;
    chrono_buttonA.style.transform = `rotate(150deg) translate(5px) rotate(-150deg)`;
    setTimeout(() => {
      chrono_buttonA.style.transform = `translate(0) rotate(0deg)`;
    }, 100);
  }

  function buttonBAnimation() {
    if (!chrono_buttonB) return;
    chrono_buttonB.style.transform = `rotate(210deg) translate(5px) rotate(-210deg)`;
    setTimeout(() => {
      chrono_buttonB.style.transform = `translate(0) rotate(0deg)`;
    }, 100);
  }

  // Event Listeners for Stopwatch Controls
  if (chrono_buttonA) {
    chrono_buttonA.addEventListener("click", () => {
      stopwatchRunning = !stopwatchRunning;
      if (stopwatchRunning) {
        rotateSec();
        rotateMin();
        rotateMili();
      }
      buttonAnimation();
    });
  }

  if (chrono_buttonB) {
    chrono_buttonB.addEventListener("click", () => {
      if (!stopwatchRunning) {
        rotationMiliDegree = rotationSecDegree = rotationMinDegree = 0;
        if (chrono_mili) chrono_mili.style.transform = `rotate(0deg)`;
        if (chrono_sec) chrono_sec.style.transform = `rotate(0deg)`;
        if (chrono_min) chrono_min.style.transform = `rotate(0deg)`;
        buttonBAnimation();
      }
    });
  }

  /* SYLVI (2026-07-02): Kick off initialization ONLY after the FULL-RES watch-face image has loaded
     (blur removed), not on DOMContentLoaded. Reason: the hero #watch_face starts as a 20px LQIP
     placeholder (blurry) and Lazysizes swaps in the full-res later. initRealTimeWatch() reveals the
     moving components (hands / sub-dials via display:block) + starts the animation — if that ran before
     the face unblurred, sharp hands floated over a blurry watch. The component images still fetch async
     in the background; they just stay display:none until the face is sharp. Guards every load path. */
  function startWhenFaceLoaded() {
    var started = false;
    function go() {
      if (started) return;
      started = true;
      initRealTimeWatch();
    }
    if (!watch_face) { // safety: no realtime hero → just init normally
      if (document.readyState !== "loading") { go(); }
      else { document.addEventListener("DOMContentLoaded", go); }
      return;
    }
    // Fast path: Shopify Theme Editor (/editor) designMode or already loaded image
    if ((window.Shopify && window.Shopify.designMode) || (watch_face.complete && watch_face.naturalWidth > 40)) {
      go();
      return;
    }
    // full-res already loaded before this JS ran? (cached / fast connection)
    if (watch_face.classList.contains("lazyloaded") && watch_face.complete && watch_face.naturalWidth > 40) {
      go();
    }
    // Lazysizes fires this on the <img> when it swaps in the real (unblurred) src
    watch_face.addEventListener("lazyloaded", function () {
      if (watch_face.complete && watch_face.naturalWidth > 40) { go(); }
      else { watch_face.addEventListener("load", go, { once: true }); }
    }, { once: true });
    // A plain load can also fire when the full-res src is set — reveal only if it's the real image (>40px)
    watch_face.addEventListener("load", function () {
      if (watch_face.classList.contains("lazyloaded") || watch_face.naturalWidth > 40) { go(); }
    });
    // Safety fallback: never leave the watch permanently hidden if events are missed
    window.addEventListener("load", function () {
      if (watch_face.complete && watch_face.naturalWidth > 40) { go(); }
    }, { once: true });
    // Hard timeout backstop (e.g. Lazysizes disabled / image error) so hands still appear (1500ms max)
    setTimeout(function () { go(); }, 1500);
  }
  startWhenFaceLoaded();
};

// Ensure the theme.RealTime() runs when DOM is fully loaded
function DOMready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

// Start real-time clock on initial load
DOMready(function () {
  if (window.theme && typeof window.theme.RealTime === 'function') {
    window.theme.RealTime();
  }
});

// Shopify Theme Editor (/editor) lifecycle events support
if (typeof document !== 'undefined') {
  document.addEventListener("shopify:section:load", function () {
    if (window.theme && typeof window.theme.RealTime === 'function') {
      window.theme.RealTime();
    }
  });
  document.addEventListener("shopify:section:select", function () {
    if (window.theme && typeof window.theme.RealTime === 'function') {
      window.theme.RealTime();
    }
  });
  document.addEventListener("shopify:section:reorder", function () {
    if (window.theme && typeof window.theme.RealTime === 'function') {
      window.theme.RealTime();
    }
  });
  document.addEventListener("variantChange", function () {
    if (window.theme && typeof window.theme.RealTime === 'function') {
      setTimeout(function () { window.theme.RealTime(); }, 50);
    }
  });
  document.addEventListener("theme:variant:change", function () {
    if (window.theme && typeof window.theme.RealTime === 'function') {
      setTimeout(function () { window.theme.RealTime(); }, 50);
    }
  });
}
